const ConfigApp = {
  accessToken: "accessTokenAgent",
  refreshToken: "refreshTokenAgent",

  userInfo: "userInfoAgent",
};

export default ConfigApp;
